import { createContext, useContext } from 'react';
import type { AnyFormApi } from '@tanstack/react-form';

const CreateSixFormContext = createContext<AnyFormApi | null>(null);

export const CreateSixFormProvider = CreateSixFormContext.Provider;

export function useCreateSixForm(): AnyFormApi {
  const form = useContext(CreateSixFormContext);
  if (form === null) {
    throw new Error('useCreateSixForm must be used within a CreateSixFormProvider');
  }
  return form;
}
